import React, { useState } from "react";
import { getAssets } from "@unisearch/helpers";
import dynamic from "next/dynamic";
import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import Image from "next/image";
const ModalVideo = dynamic(() => import("react-modal-video"), { ssr: false });

export const BlogSingleBanner = ({ blog }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <section
        className="pb-6 lg:pb-10"
        style={{
          backgroundImage: "linear-gradient(180deg, #f1f5fd 50%, #ffffff 50%)",
        }}
      >
        <div className="container">
          <div className="max-w-[970px] mx-auto relative">
            <Image
              blurDataURL={getAssets(
                "assets/images/image_placeholder_big.webp"
              )}
              placeholder="blur"
              src={
                blog?.posterImage?.src ||
                blog?.featureImage?.src ||
                getAssets("assets/images/image_placeholder_big.webp")
              }
              alt={`UniSearch - ${blog?.title}`}
              width={970}
              height={545}
              className="rounded-lg"
            />
            {blog && blog?.videoType && (
              <PlayButtonWithRipple onClick={() => setOpen(true)} />
            )}
          </div>
        </div>
      </section>

      {blog && blog?.videoType && blog?.embeddedCode && (
        <ModalVideo
          channel="youtube"
          autoplay
          videoId={blog?.embeddedCode}
          isOpen={isOpen}
          onClose={() => setOpen(false)}
        />
      )}

      {blog && blog?.videoType && blog?.videoUpload && (
        <ModalVideo
          channel="custom"
          autoplay
          url={blog?.videoUpload?.src}
          isOpen={isOpen}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default BlogSingleBanner;
